import {IFormConfig} from '../../../@interfaces/services/Database';
import {StringArray} from '../../../@interfaces/types';
import AbstractModel from './AbstractModel';

export default class FormConfig extends AbstractModel<IFormConfig> implements IFormConfig {
	readonly name!: string;
	readonly config!: StringArray<any>;

	protected get table() {
		return this.connection.formsConfigs;
	}
}
